import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import Paper from '@material-ui/core/Paper';
import { formatDate, toDisplayDecimal, addPad } from '../../utils';
import i18next from 'i18next';
import PropTypes from 'prop-types'
import styles from '../../styles/payrollRegister.module.css';

const useStyles = makeStyles({
    table: {
        '& td': {
            fontSize: 16,
            '@media (max-width: 600px)': {
                fontSize: 13,
            }
        },
        '& td:first-child': {
            width: '30%',
            '@media (max-width: 600px)': {
                width: '36%'
            }
        },
    },
    head: {
        lineHeight: '0.5'
    },
    labelSubCode: {
        textAlign: 'right'
    }
});

const StyledFirstTableCell = withStyles((theme) => ({
    body: {
        fontSize: 14,
        width: '200px',
        '@media (max-width: 600px)': {
            width: "170px"
        },
        fontWeight: "bold"
    },
}))(TableCell);

const StyledSecondTableCell = withStyles((theme) => ({
    head: {
        color: '#000000!important',
        fontSize: 16,
        width: '75%',
        '@media (max-width: 600px)': {
            fontSize: 12,
            width: "75%"
        },
        fontWeight: 'bold'
    },
    body: {
        fontSize: 16,
        '@media (max-width: 600px)': {
            fontSize: 11,
        }
    },
}))(TableCell);

export default function PayrollDisplay(props) {

    const classes = useStyles();
    const { data, handleOpenPdf } = props;

    return (
        <div id="divDetailPayroll" className={styles.detailPayroll} onClick={() => { handleOpenPdf(data.title, data.fileContentBase64); }}>
            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="spanning table">
                    <TableBody>
                        <TableRow>
                            <StyledFirstTableCell>{`${i18next.t('payrollRegister:list.payDate')}`}</StyledFirstTableCell>
                            <StyledSecondTableCell>{formatDate(data.payDate, 'date')}</StyledSecondTableCell>
                        </TableRow>

                        <TableRow>
                            <StyledFirstTableCell>{`${i18next.t('payrollRegister:list.netPay')}`}</StyledFirstTableCell>
                            <StyledSecondTableCell>{toDisplayDecimal(data.netPay, 2, true)}</StyledSecondTableCell>
                        </TableRow>

                        <TableRow>
                            <StyledFirstTableCell>{`${i18next.t('payrollRegister:list.grossAmount')}`}</StyledFirstTableCell>
                            <StyledSecondTableCell>{toDisplayDecimal(data.grossPay, 2, true)}</StyledSecondTableCell>
                        </TableRow>

                        <TableRow>
                            <StyledFirstTableCell>{`${i18next.t('payrollRegister:list.targetPeriod')}`}</StyledFirstTableCell>
                        <StyledSecondTableCell>{`${data.year}-${addPad(data.period)}`}</StyledSecondTableCell>
                        </TableRow>

                        <TableRow>
                            <StyledFirstTableCell>{`${i18next.t('payrollRegister:list.payPeriod')}`}</StyledFirstTableCell>
                            <StyledSecondTableCell>{`${i18next.t('common:from')} ${formatDate(data.startDate, 'date')} ${i18next.t('common:to')} ${formatDate(data.endDate, 'date')}`}</StyledSecondTableCell>
                        </TableRow>

                        <TableRow>
                            <StyledFirstTableCell>{`${i18next.t('payrollRegister:list.typePayment')}`}</StyledFirstTableCell>
                            <StyledSecondTableCell>{data.isDirectDepositMode == 'O' ? `${i18next.t('payrollRegister:list.directDeposit')}` : `${i18next.t('payrollRegister:list.cheque')}`}</StyledSecondTableCell>
                        </TableRow>

                        {data.fileContentBase64 != null &&
                            <TableRow>
                                <StyledFirstTableCell><PictureAsPdfIcon /></StyledFirstTableCell>
                                <StyledSecondTableCell>{data.title}</StyledSecondTableCell>
                            </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </div >
    );
}

PayrollDisplay.propTypes = {
    data: PropTypes.object.isRequired
}